import { toast } from "sonner";
import axiosInstance from "../../utility/axiosInstance";
import axios from "axios";
import {
  Document,
  UploadDocumentResponse,
  GetDocumentsResponse,
} from "../../store/types/document";

// Document service
export const documentService = {
  // Upload document (SLA/MSA/MOU/ONBOARDING_FORM) with signature
  uploadDocument: async (
    organizationId: string,
    documentType:
      | "SLA"
      | "MSA"
      | "MDA"
      | "ONBOARDING_FORM"
      | "GO_LIVE"
      | "DPA"
      | "GO_LIVE_COMPLETION",
    file: File,
  ): Promise<UploadDocumentResponse> => {
    try {
      const formData = new FormData();
      formData.append("organizationId", organizationId);
      formData.append("documentType", documentType);
      formData.append("file", file);

      const response = await axiosInstance.post<UploadDocumentResponse>(
        "/organizations/documents/sign",
        formData,
        // {
        //   headers: {
        //     "Content-Type": "multipart/form-data",
        //   },
        // },
      );

      toast.success(response?.data?.message || "Document uploaded");
      return response.data;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        toast.error(
          error?.response?.data?.message || "Failed to upload document",
        );
      }
      throw new Error("An unexpected error occurred while uploading document");
    }
  },

  // Get all documents for an organization
  getDocuments: async (
    organizationId: string,
  ): Promise<GetDocumentsResponse> => {
    try {
      const response = await axiosInstance.get<GetDocumentsResponse>(
        `/organizations/${organizationId}/documents`,
      );
      return response.data;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        // Don't show toast for 404 (no documents found)
        if (error.response?.status !== 404) {
          toast.error(
            error?.response?.data?.message || "Failed to fetch documents",
          );
        }
      }
      throw new Error("An unexpected error occurred while fetching documents");
    }
  },

  // Standalone endpoint for organizations to get their own documents
  getOrgDocuments: async (
    organizationId: string,
  ): Promise<GetDocumentsResponse> => {
    try {
      const response = await axiosInstance.get<GetDocumentsResponse>(
        `/organizations/${organizationId}/documents`,
      );
      return response.data;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        // Don't show toast for 404 (no documents found)
        if (error.response?.status !== 404) {
          toast.error(
            error?.response?.data?.message ||
              "Failed to fetch organization documents",
          );
        }
      }
      throw new Error(
        "An unexpected error occurred while fetching organization documents",
      );
    }
  },

  noUploadDocument: async (
    organizationId: string,
    documentType:
      | "SLA"
      | "MSA"
      | "MDA"
      | "ONBOARDING_FORM"
      | "GO_LIVE"
      | "DPA"
      | "GO_LIVE_COMPLETION",
  ): Promise<UploadDocumentResponse> => {
    try {
      const formData = new FormData();
      formData.append("organizationId", organizationId);
      formData.append("documentType", documentType);

      const response = await axiosInstance.post<UploadDocumentResponse>(
        "/organizations/documents/sign",
        formData,
        // {
        //   headers: {
        //     "Content-Type": "multipart/form-data",
        //   },
        // },
      );

      toast.success(response?.data?.message || "Document uploaded");
      return response.data;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        toast.error(
          error?.response?.data?.message || "Failed to upload document",
        );
      }
      throw new Error("An unexpected error occurred while uploading document");
    }
  },
};
